import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { ProfiledInfoRoute } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class ProfiledRouteInfo {
  private _http = inject(HttpClient);
  
  private _profiledRouteInfo = signal<ProfiledInfoRoute | null>(null);
  public profiledRouteInfo = this._profiledRouteInfo.asReadonly();
  
  public setProfileRouteInfo(data: ProfiledInfoRoute | null): void {
    this._profiledRouteInfo.set(data);
  }
  
  getProfiledRouteInfo(routeToken: string): void {
    const apiUrl = 'https://dev.gpt.cms-iurban.com/fitur/user-profile';
    const params = { route_token: routeToken };
    
    this._http.get<ProfiledInfoRoute>(apiUrl, { params }).subscribe({
      next: (data) => {
        this._profiledRouteInfo.set(data);
      },
      error: (error) => {
        console.error('Error fetching profiled route info:', error);
        this._profiledRouteInfo.set(null);
      }
    });
  }
}
